"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _ChevronLeft = _interopRequireDefault(require("../../Icons/ChevronLeft"));

var _ChevronRight = _interopRequireDefault(require("../../Icons/ChevronRight"));

var _colors = _interopRequireDefault(require("../../../constants/colors"));

var _spacing = _interopRequireDefault(require("../../../constants/spacing"));

var _vars = _interopRequireDefault(require("../../../constants/vars"));

var _breakpoints = _interopRequireDefault(require("../../../constants/breakpoints"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _templateObject7() {
  var data = _taggedTemplateLiteralLoose(["\n\tfont-weight: ", ";\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tflex-wrap: wrap;\n\tmargin: 0 ", ";\n\ttext-align: center;\n\tmin-width: 130px;\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteralLoose(["\n\t", ";\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteralLoose(["\n\t", ";\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteralLoose(["\n\tcursor: pointer;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n\tjustify-content: flex-end;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n\tdisplay: flex;\n\tflex: 0 1 40px;\n\tmax-width: 40px;\n\talign-items: center;\n\tjustify-content: flex-start;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n\tpadding: ", " ", " ", ";\n\tmargin: 0 40px;\n\tdisplay: flex;\n\talign-items: center;\n\tdisplay: flex;\n\tjustify-content: center;\n\n\t@media (min-width: ", ") {\n\t\tpadding: ", " ", " ", ";\n\t}\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

var HeaderWrapper = _styledComponents.default.div(_templateObject(), _spacing.default.s3, _spacing.default.s2, _spacing.default.s2, _breakpoints.default.tablet, _spacing.default.s2, _spacing.default.s2, _spacing.default.s1);

HeaderWrapper.displayName = 'HeaderWrapper';

var ChevronLeft = _styledComponents.default.div(_templateObject2());

ChevronLeft.displayName = 'ChevronLeft';
var ChevronRight = (0, _styledComponents.default)(ChevronLeft)(_templateObject3());
ChevronRight.displayName = 'ChevronRight';
var cursor = (0, _styledComponents.css)(_templateObject4());
var ChevronLeftNav = (0, _styledComponents.default)(_ChevronLeft.default)(_templateObject5(), cursor);
ChevronLeftNav.displayName = 'ChevronLeftNav';
var ChevronRightNav = (0, _styledComponents.default)(_ChevronRight.default)(_templateObject6(), cursor);
ChevronRightNav.displayName = 'ChevronRightNav';

var TextContent = _styledComponents.default.span(_templateObject7(), _vars.default.fontWeight, _spacing.default.s2);

TextContent.displayName = 'TextContent';

var Header = function Header(_ref) {
  var children = _ref.children,
      showNext = _ref.showNext,
      onNext = _ref.onNext,
      showPrevious = _ref.showPrevious,
      onPrevious = _ref.onPrevious,
      onTextContent = _ref.onTextContent;
  return _react.default.createElement(HeaderWrapper, null, _react.default.createElement(ChevronLeft, null, showPrevious && _react.default.createElement(ChevronLeftNav, {
    onClick: onPrevious,
    size: 14,
    color: _colors.default.secondary
  })), _react.default.createElement(TextContent, {
    onClick: onTextContent
  }, children), _react.default.createElement(ChevronRight, null, showNext && _react.default.createElement(ChevronRightNav, {
    onClick: onNext,
    size: 14,
    color: _colors.default.secondary
  })));
};

Header.displayName = 'Header';
Header.propTypes = {
  children: _propTypes.node,
  showNext: _propTypes.bool,
  onNext: _propTypes.func.isRequired,
  showPrevious: _propTypes.bool,
  onPrevious: _propTypes.func.isRequired,
  onTextContent: _propTypes.func
};
Header.defaultProps = {
  children: '',
  showNext: false,
  showPrevious: false,
  onTextContent: undefined
};
var _default = Header;
exports.default = _default;